jQuery(function ($) {
  if (jQuery(".wpcf7-submit").length) {
    jQuery(".wpcf7-submit").on("click", function () {
      jQuery(".wpcf7-form-control-wrap").addClass("is-show");
    });
  }
});
